import React from "react";
import { clearHtml } from "shared/lib/sanitizer";

export default (props) => {
  const { value, style } = props;

  return <div style={style} dangerouslySetInnerHTML={{ __html: clearHtml(value) }} />;
}
